import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';  
import UserSidebar from './UserSidebar';
import UserHeader from './UserHeader';

const UserLayout = () => {

  useEffect(() => {
    // Place your jQuery DOM logic here
    const $ = window.jQuery;

    if (!$) return;

    // Sidebar submenu toggle
    $(".sidebar-menu .dropdown").on("click", function () {
      const item = $(this);
      item.siblings(".dropdown").children(".sidebar-submenu").slideUp();
      item.siblings(".dropdown").removeClass("dropdown-open open");
      item.children(".sidebar-submenu").slideToggle();
      item.toggleClass("dropdown-open");
    });

    $(".sidebar-toggle").on("click", function () {
      $(this).toggleClass("active");
      $(".sidebar").toggleClass("active");
      $(".dashboard-main").toggleClass("active");
    });

    $(".sidebar-mobile-toggle").on("click", function () {
      $(".sidebar").addClass("sidebar-open");
      $("body").addClass("overlay-active");
    });

    $(".sidebar-close-btn").on("click", function () {
      $(".sidebar").removeClass("sidebar-open");
      $("body").removeClass("overlay-active");
    });

    // Highlight active menu
    const nk = window.location.href;
    $("ul#sidebar-menu a").filter(function () {
      return this.href === nk;
    }).addClass("active-page").parent().addClass("active-page");

    // Theme toggle
    const button = document.querySelector("[data-theme-toggle]");
    const localStorageTheme = localStorage.getItem("theme");

    const calculateSettingAsThemeString = ({ localStorageTheme }) =>
      localStorageTheme !== null ? localStorageTheme : "light";

    const updateButton = ({ buttonEl, isDark }) => {
      const newCta = isDark ? "dark" : "light";
      buttonEl?.setAttribute("aria-label", newCta);
      buttonEl && (buttonEl.innerText = newCta);
    };

    const updateThemeOnHtmlEl = ({ theme }) => {
      document.querySelector("html").setAttribute("data-theme", theme);
    };

    let currentThemeSetting = calculateSettingAsThemeString({ localStorageTheme });
    updateButton({ buttonEl: button, isDark: currentThemeSetting === "dark" });
    updateThemeOnHtmlEl({ theme: currentThemeSetting });

    button?.addEventListener("click", () => {
      const newTheme = currentThemeSetting === "dark" ? "light" : "dark";
      localStorage.setItem("theme", newTheme);
      updateButton({ buttonEl: button, isDark: newTheme === "dark" });
      updateThemeOnHtmlEl({ theme: newTheme });
      currentThemeSetting = newTheme;
    });

    // Table: Select All
    $('#selectAll').on('change', function () {
      $('.form-check .form-check-input').prop('checked', $(this).prop('checked'));
    });

    // Table: Remove row
    $('.remove-btn').on('click', function () {
      $(this).closest('tr').remove();
      if ($('.table tbody tr').length === 0) {
        $('.table').addClass('bg-danger');
        $('.no-items-found').show();
      }
    });

    // Cleanup event listeners on unmount
    return () => {
      $(".sidebar-menu .dropdown").off("click");
      $(".sidebar-toggle").off("click");
      $(".sidebar-mobile-toggle").off("click");
      $(".sidebar-close-btn").off("click");
      $('#selectAll').off("change");
      $('.remove-btn').off("click");
      button?.removeEventListener("click", () => { });
    };
  }, []);

  return (
    <>
      <UserSidebar />
      <main className="dashboard-main" style={{ background: '#fff' }}>
        <UserHeader />
        <div className="dashboard-main-body p-0">
          <Outlet />
        </div>
      </main>

    </>
  );
};

export default UserLayout; 